import Tab from '@mui/material/Tab';
import Tabs from '@mui/material/Tabs';

import { useApp } from '@/presentation/hooks/use-app.js';
import type { TabIndex } from '@/presentation/pages/developments/development-detail/utils/get-visible-tabs.js';

const TAB_LABELS: Array<{ index: TabIndex; key: string }> = [
    { index: 0, key: 'tabs.summary' },
    { index: 1, key: 'tabs.efIa' },
    { index: 2, key: 'tabs.estimate' },
    { index: 3, key: 'tabs.documents' },
    { index: 4, key: 'tabs.validation' },
    { index: 5, key: 'tabs.requests' },
    { index: 6, key: 'tabs.audit' },
    { index: 7, key: 'tabs.development' }
];

interface Props {
    currentTab: TabIndex;
    visibleTabs: TabIndex[];
    isFullHeightTab: boolean;
    onChange: (tab: TabIndex) => void;
}

export function DevelopmentDetailTabs({ currentTab, visibleTabs, isFullHeightTab, onChange }: Props) {
    const { translate } = useApp();
    const tabLabelMap = new Map(TAB_LABELS.map((t) => [t.index, t.key]));
    const visibleTabLabels = visibleTabs.map((idx) => ({ index: idx, key: tabLabelMap.get(idx)! }));

    return (
        <Tabs value={currentTab} onChange={(_, v: TabIndex) => onChange(v)} sx={{ borderBottom: 1, borderColor: 'divider', mb: isFullHeightTab ? 1 : 2 }}>
            {visibleTabLabels.map(({ index, key }) => (
                <Tab key={index} value={index} label={translate(key)} />
            ))}
        </Tabs>
    );
}
